export default __webpack_public_path__ + "static/M3-e830c9e7e8ac5764e3de9a48b61d27e7.png";